module.exports = __webpack_public_path__ + "img/9dccbc2.jpg";